import React, { useEffect } from "react";
import PropTypes from "prop-types";

// Components
import { Container, Spinner } from "react-bootstrap";
import { connect } from "react-redux";

// Actions
import { logout } from "../actions/Auth";

const Logout = ({ logout }) => {
  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Container className="text-center mt-4">
      <h1>Log out</h1>
      <Spinner
        as="span"
        animation="border"
        size="sm"
        role="isProcessing"
        className="ml-1"
        aria-hidden="true"
      />
    </Container>
  );
};

Logout.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default connect(null, { logout })(Logout);
